/** API route map: URLS.Controller.RunPayroll */
export const RunPayroll = {
      Name: 'RunPayroll/',
      PrePayrollGrid: 'pre-payroll-employees',
      HoursEarningEmployees: 'hours-earnings-employees',
      GetTimesheetEmployees: 'employee-timesheet',
      AddExtras: 'add-extras',
      AddExtrasBulk: 'add-extras-bulk',
      GetExtras: 'get-extras',
      DeleteExtras: 'delete-extra',
      UpdateStep: 'update-step',
      PtoEmployees: 'pto-employees',
      UpdatePto: 'update-pto',
      ReviewSummary: 'review-summary',
      CompanyReview: 'company-review',
      TaxReview: 'tax-review/',
      BilledReview: 'billed-review',
      EmployeeReview: 'employee-review',
      SendToClient: 'send-to-client',
      SkipClientApproval: 'skip-client-approval',
      Initiate: 'initiate',
      PaymentReceived: 'payment-received',
      SendInvoice: 'send-invoice',
      Execute: 'execute',
      GetUnsetCodes: 'unset-codes',
      AddPayCodes: 'add-code',
      DeletePayCodes: 'delete-code',
      CalculationsAllEmployees: 'all-employees',
      CalculateTax: 'calculate-tax',
      GetEmployeeWarning: 'get-employee-warning',
      EmployeeTaxBreakdown: 'tax-breakdown',
      ReplaceCode: 'replace-code',
      EmployeeStraightHours: 'employee-straight-hours',
      UpdateTimeSheetHours: 'update-timesheet-hours',

      RemoveFromPayroll: 'remove-employee-payroll',
      RemoveFromPaygroup: 'remove-employee-paygroup',
      ChangeEmployeeStatusToActive: 'change-employee_status',
      AutoFillHours: 'auto-fill-hours',

      PreMissingEmpoyee: 'get-paygroup-employees',
      AddEmployeeToTimeSheet: 'add-employees-timesheet',
};
